export enum RoleEnum {
  Reseller = "Reseller",
  SuperAdmin = "Super Admin",
  Support = 'Soporte',
}